export function isLocalHost(): boolean {
    return window.location.href.includes('localhost') || window.location.href.includes('192.168.');
}

function getUrlAtual(): string {
    if (isLocalHost()) {
        return 'sandbox.app.mercurioapp.com.br';
    }

    return window.location.hostname;
}

export const URL_ATUAL = getUrlAtual();

export function isSandbox(): boolean {
    return window.location.href.includes('sandbox') || isLocalHost();
}

export function isMercurioSandbox(): boolean {
    return window.location.href.includes('sandbox.app.mercurioapp.com.br') || isLocalHost();
}
